import {useSelector} from 'react-redux'

import {selectUser} from 'features/User'

interface UseSSLInspectionReleaseReturnType {
  isSSLInspectionToggleReleased: boolean
}
export const useSSLInspectionRelease =
  (): UseSSLInspectionReleaseReturnType => {
    const {primaryDomain} = useSelector(selectUser)
    const isSSLInspectionToggleReleased =
      allowedDomainsForSSLInspectionToggleProdRelease.has(primaryDomain)

    return {isSSLInspectionToggleReleased}
  }

const allowedDomainsForSSLInspectionToggleProdRelease = new Set([
  'dope.security',
  'exigerinc.onmicrosoft.com',
])
